import "./TableLineSm.scss";

import React from "react";

interface TableLineSmProps {
  title: React.ReactNode;
  controls?: React.ReactNode;
}

export function TableCellSm({
  title,
  children,
}: React.PropsWithChildren<TableLineSmProps>) {
  return (
    <div>
      <div className="head-cell-content my-2">{title}</div>
      {children}
    </div>
  );
}

interface TableCellSmProps {
  title: React.ReactNode;
  controls?: React.ReactNode;
  colspan?: number;
}

export function TableLineSm({
  title,
  children,
  controls,
  colspan = 3,
}: React.PropsWithChildren<TableCellSmProps>) {
  return (
    <div className="table-line-sm">
      <div className="table-line-sm-content">
        <div className="head-cell-title">{title}</div>
        <div
          className="line-grid"
          style={{ gridTemplateColumns: `2fr repeat(${colspan - 1}, 1fr)` }}
        >
          {children}
        </div>
      </div>
      {!!controls && <div className="table-line-sm-controls">{controls}</div>}
    </div>
  );
}
